import type * as types from './types';

type TransformOriginSide = 'bottom' | 'left' | 'right' | 'top';

type _TransformOrigin<T extends TransformOriginSide> = T extends TransformOriginSide
  ? `${T} ${Exclude<TransformOriginSide, T>}` | T
  : never;

export type AnimatedPopoverTransformOrigin = _TransformOrigin<TransformOriginSide>;

/* Some of these may need fine tuning as the Popover component becomes used more heavily - that is
   fine, please make those adjustments here. */
export const PopoverPlacementsToTransformOrigins: Record<
  types.PopperPlacement,
  AnimatedPopoverTransformOrigin
> = {
  auto: 'top',
  'auto-end': 'top',
  'auto-start': 'top',
  bottom: 'top',
  'bottom-end': 'right top',
  'bottom-start': 'left top',
  left: 'right',
  'left-end': 'right',
  'left-start': 'right',
  right: 'left',
  'right-end': 'left',
  'right-start': 'right',
  top: 'bottom',
  'top-end': 'bottom',
  'top-start': 'bottom',
};
